<template>
    <div class="first-row">
        <!-- >>> Outward -->
        <div v-if="flightdirection === 'outward'">
            <h4 class="box-title">{{ flight.depArprt.i }} {{ to[getCurrentLocale] }} {{ flight.desArprt.i }}<small>{{ whichFlightDirection(flight.depArprt.i) }} - {{ flight.no }}</small></h4>
            <a class="button btn-mini silver" v-bind:class="{ yellow: getBookingFlightIdSelectedOutward === flight.id }" style="cursor: initial; outline: none !important; outline-style: none !important; color: #4f657e;">STOPS: {{ flight.stpArprt === null ? '0' : '1' }}</a>

            <div class="amenities" v-if="getBookingFlightIdSelectedOutward === flight.id && (flight.prcs[0] !== undefined && flight.warn === '')">                                                      <!-- booking on -->
                <i class="soap-icon-passenger circle yellowchossen" v-tooltip="amenities_services[getCurrentLocale]" v-if="flight.srvcSeat === true"></i>
                <i class="soap-icon-fork circle yellowchossen" v-tooltip="amenities_meal[getCurrentLocale]" v-if="flight.serviceCategories.meal === true"></i>
                <i class="soap-icon-suitcase circle yellowchossen" v-tooltip="amenities_lugagge[getCurrentLocale]" v-if="flight.serviceCategories.baggage === true"></i>
            </div>
            <div class="amenities" v-if="getBookingFlightIdSelectedOutward !== flight.id || (flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY')">      <!-- booking off -->
                <i class="soap-icon-passenger circle greychossen" v-if="flight.srvcSeat === true"></i>
                <i class="soap-icon-fork circle greychossen" v-if="flight.serviceCategories.meal === true"></i>
                <i class="soap-icon-suitcase circle greychossen" v-if="flight.serviceCategories.baggage === true"></i>
            </div>
        </div>
        <!-- <<< Outward -->

        <!-- >>> Return -->
        <div v-if="flightdirection === 'return'">
            <h4 class="box-title">{{ flight.depArprt.i }} {{ to[getCurrentLocale] }} {{ flight.desArprt.i }}<small>{{ whichFlightDirection(flight.depArprt.i) }} - {{ flight.no }}</small></h4>
            <a class="button btn-mini silver" v-bind:class="{ yellow: getBookingFlightIdSelectedReturn === flight.id }" style="cursor: initial; outline: none !important; outline-style: none !important; color: #4f657e;">STOPS: {{ flight.stpArprt === null ? '0' : '1' }}</a>

            <div class="amenities" v-if="getBookingFlightIdSelectedReturn === flight.id && (flight.prcs[0] !== undefined && flight.warn === '')">                                                       <!-- booking on -->
                <i class="soap-icon-passenger circle yellowchossen" v-tooltip="amenities_services[getCurrentLocale]" v-if="flight.srvcSeat === true"></i>
                <i class="soap-icon-fork circle yellowchossen" v-tooltip="amenities_meal[getCurrentLocale]" v-if="flight.serviceCategories.meal === true"></i>
                <i class="soap-icon-suitcase circle yellowchossen" v-tooltip="amenities_lugagge[getCurrentLocale]" v-if="flight.serviceCategories.baggage === true"></i>
            </div>
            <div class="amenities" v-if="(getBookingFlightIdSelectedReturn !== flight.id) || (flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY')">     <!-- booking off -->
                <i class="soap-icon-passenger circle greychossen" v-if="flight.srvcSeat === true"></i>
                <i class="soap-icon-fork circle greychossen" v-if="flight.serviceCategories.meal === true"></i>
                <i class="soap-icon-suitcase circle greychossen" v-if="flight.serviceCategories.baggage === true"></i>
            </div>
        </div>
        <!-- <<< Return -->

        <!-- >>> FlightPrice - 'NOT SOLD OUT', NO WARNING -->
        <span v-if="flight.prcs[0] !== undefined && flight.warn === ''" class="price">
            <a class="collapsed" v-bind:href="'#acc' + flight.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + flight.id" v-tooltip="seetaxes[getCurrentLocale]">
                <small>{{ avgpers[getCurrentLocale] }}</small>{{ Number(flight.prcs[0].amnt) + Number(flight.prcs[0].tax.tot) | rndAmntRUAFWZ }}
            </a>
        </span>
        <!-- >>> FlightPrice - 'SOLD OUT', SOME WARNING  -->
        <span v-if="flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY'" class="price" style="color: #D9D9D8; text-transform: none;">
            <small style="color: #D9D9D8;">{{ avgpers[getCurrentLocale] }}</small><span style="color: rgb(142, 142, 142);">{{ out[getCurrentLocale] }}</span>
        </span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flight', 'flightdirection', 'modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                outwardflight: {
                    en: 'Outward Flight',
                    de: 'Hinflug',
                },
                returnflight: {
                    en: 'Return Flight',
                    de: 'Rückflug',
                },
                // ----------------------------------------
                out: {
                    en: 'SOLD OUT',
                    de: 'AUSV.'
                },
                // ----------------------------------------
                to: {
                    en: 'to',
                    de: 'nach',
                },
                // ----------------------------------------
                amenities_services: {
                    en: 'Additional services can be reserved on this flight: Seats' ,
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Sitzplätze',
                },
                amenities_meal: {
                    en: 'Additional services can be reserved on this flight.: Meals',
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Essen',
                },
                amenities_lugagge: {
                    en: 'Additional services can be reserved on this flight.: Additional Luggage',
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Zusätzliches Gepäck',
                },
                // ----------------------------------------
                seetaxes: {
                    en: 'See Taxes & Fees',
                    de: 'Steuern & Gebühren ansehen',
                },
                // ----------------------------------------
                avgpers: {
                    en: 'AVG/PERSON',
                    de: 'PRO PERSON'
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getBookingFlightIdSelectedOutward',
                'getBookingFlightIdSelectedReturn',
                'getBookingDepArprtCode',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
            ]),


            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * whichFlightDirection()
            *
            * Desc:
            *
            * @param {string} apt (Airports)
            * @return {string}
            */
            whichFlightDirection: function(apt) {

                var me = this;


                me.$toc('>>> shared/flightsearch/componenets/firstrow/FirstRowBooking.vue >>> whichFlightDirection');
                if (apt === this.getBookingDepArprtCode) {
                    return this.outwardflight[this.getCurrentLocale];
                } else {
                    return this.returnflight[this.getCurrentLocale];
                }

            }, // eof whichFlightDirection()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>



// WEBPACK FOOTER //
// src/components/shared/flightsearch/components/fsr/firstrow/FirstRowBooking.vue